<div class="grid-input" [class.error]="canShowRequiredErrorElement()" fxLayout="column" *ngIf="canShowInputElement()">
  <mat-form-field class="no-subscript">
    <mat-label class="b1 hint">{{ getLabel() | bmsTranslate }}</mat-label>
    <input
      #inputElement
      *ngIf="!canShowStringInput()"
      matInput
      vdwL10nDecimal
      [attr.min]="minValue"
      type="number"
      [value]="getValue()"
      (input)="setValue(inputElement.value)"
      (click)="stopPropagation($event)"
    />
    <input #inputElement *ngIf="canShowStringInput()" matInput type="text" [value]="getValue()" (input)="setValue(inputElement.value)" vdwAlphabet (click)="stopPropagation($event)" />
  </mat-form-field>
</div>
